<template></template>

<script>
import { ref } from 'vue';
import { toast } from "vue3-toastify";
import { GamepadListener } from 'gamepad.js';
import { bindKey, unbindKey } from '@rwh/keystrokes'

export default {
  name: "ExternalControl",
  components: {
  },
  setup() {
    return {
      keysLayout: ref({
        fr: ['A', 'Z', 'E', 'Q', 'S', 'D', /**/ 'R', 'F', /**/ 'W', 'X', 'C', 'V'],
        en: ['Q', 'W', 'E', 'A', 'S', 'D', /**/ 'R', 'F', /**/ 'Z', 'X', 'C', 'V'],
      }),

      keysToAction: ref({}),
      pressedKey: ref([]),

      /** ----------- */

      gamepadListener: ref(false),
      gamepadToAction: ref({}),
    };
  },

  mounted() {
    this.initBindKeys();
    this.initGameController();

    this.$root.controller = this;
  },

  methods: {
    /** --- initBindKeys --- */
    initBindKeys() {
      this.unBindKeys();
      let layout = $root.user.getkeysLayout()

      for (let key of this.keysLayout[layout]) {
        bindKey(key, {
          onPressed: () => {
            this.visualKey(key, true);
            this.actionKey(key, 'onPressed');
          },
          onPressedWithRepeat: () => {
            this.actionKey(key, 'onPressedWithRepeat')
          },
          onReleased: () => this.visualKey(key, false),
        })
      }
    },

    unBindKeys() {
      for (let layout in this.keysLayout) {
        for (let key of this.keysLayout[layout]) {
          unbindKey(key);
        }
      }
    },

    actionKey(key, actiontype) {
      let instruction = this.keyboard2Instruction(key);
      if (instruction == undefined) return;
      if (instruction.type !== actiontype) return;

      instruction.action();
    },

    visualKey(key, press) {
      if (press && !this.pressedKey.includes(key)) {
        let instruction = this.keyboard2Instruction(key);
        if (instruction == undefined) return;
        this.pressedKey.push(instruction.name);
      }
      else {
        this.pressedKey = this.pressedKey.filter((el) => {
          let instruction = this.keyboard2Instruction(key);
          if (instruction == undefined) return true;
          return el != instruction.name;
        });
      }
    },

    keyPressed(key) {
      return this.pressedKey.includes(key)
    },

    keyboard2Instruction(key) {
      let layout = $root.user.getkeysLayout()
      if (this.keysToAction[layout] == undefined) return undefined;
      return this.keysToAction[layout][key]
    },

    instruction2Keyboard(instruction) {
      let layout = $root.user.getkeysLayout()
      if (this.keysToAction[layout] == undefined) return undefined;
      return Object.keys(this.keysToAction[layout]).find(key => this.keysToAction[layout][key].name == instruction);
    },

    instruction2KeyboardLetter(instruction) {
      let layout = $root.user.getkeysLayout()
      if (this.keysToAction[layout] == undefined) return '';
      return Object.keys(this.keysToAction[layout]).find(key => this.keysToAction[layout][key].name == instruction);
    },

    /** --- initGameController --- */

    initGameController() {
      this.gamepadListener = new GamepadListener({
        button: {
          analog: false
        },
        axis: {
          precision: 3,
          deadZone: 0.1
        }
      });

      this.gamepadListener.on('gamepad:connected', event => {
        toast.success("Manette " + (event.detail.index + 1) + " connecter", this.$root.toastConfig);
      });

      this.gamepadListener.on('gamepad:disconnected', event => {
        toast.error("Manette " + (event.detail.index + 1) + " déconnecter", this.$root.toastConfig);
      });

      this.gamepadListener.start();

      this.bindGamepad();
    },

    bindGamepad() {
      this.axe0();
      this.axe1();
      this.axe2();
    },

    axe0() {
      var clock = 0;
      this.gamepadListener.on('gamepad:0:axis:0', async event => {
        if (this.gamepadToAction['AXE'] == undefined) return;
        if (this.gamepadToAction['AXE']['0'] == undefined) return;

        if (this.gamepadToAction['AXE']['0'].clock == undefined) {
          this.gamepadToAction['AXE']['0'].action(event.detail.value);
        }
        else {
          if (clock % this.gamepadToAction['AXE']['0'].clock == 0) {
            this.gamepadToAction['AXE']['0'].action(event.detail.value);
          }
          clock++;
        }
      });
    },
    axe1() {
      var clock = 0;
      this.gamepadListener.on('gamepad:0:axis:1', async event => {
        if (this.gamepadToAction['AXE'] == undefined) return;
        if (this.gamepadToAction['AXE']['1'] == undefined) return;

        if (this.gamepadToAction['AXE']['1'].clock == undefined) {
          this.gamepadToAction['AXE']['1'].action(event.detail.value);
        }
        else {
          if (clock % this.gamepadToAction['AXE']['1'].clock == 0) {
            this.gamepadToAction['AXE']['1'].action(event.detail.value);
          }
          clock++;
        }
      });
    },
    axe2() {
      var clock = 0;
      this.gamepadListener.on('gamepad:0:axis:2', async event => {
        if (this.gamepadToAction['AXE'] == undefined) return;
        if (this.gamepadToAction['AXE']['2'] == undefined) return;

        if (this.gamepadToAction['AXE']['2'].clock == undefined) {
          this.gamepadToAction['AXE']['2'].action(event.detail.value);
        }
        else {
          if (clock % this.gamepadToAction['AXE']['2'].clock == 0) {
            this.gamepadToAction['AXE']['2'].action(event.detail.value);
          }
          clock++;
        }
      });
    },
  },
};
</script>
